import {Input} from '@blesk-frontend/ui';
import {useNavigate, useSearch} from '@tanstack/react-router';
import {X} from 'lucide-react';
import {useEffect} from 'react';
import {useForm} from 'react-hook-form';

export const AppSidebarSearch = () => {
  const navigate = useNavigate();
  const {search} = useSearch({strict: false});

  const {register, setValue, setFocus, watch, handleSubmit} = useForm<{search: string}>({
    defaultValues: {
      search: '',
    },
  });

  const searchValue = watch('search');

  useEffect(() => {
    setValue('search', search || '');
  }, [search, setValue]);

  const onSubmit = handleSubmit((data) => {
    navigate({
      to: '/',
      search: {search: data.search},
    });
  });

  const onClickClear = () => {
    setValue('search', '');
    setFocus('search');
    navigate({
      to: '/',
    });
  };

  return (
    <form onSubmit={onSubmit}>
      <Input
        {...register('search', {required: true})}
        placeholder="Поиск"
        extra={
          searchValue && (
            <X
              className="size-5 cursor-pointer transition-all hover:text-brand-secondary-hover active:scale-[0.95]"
              onClick={onClickClear}
              onMouseDown={(e) => e.preventDefault()}
            />
          )
        }
      />
    </form>
  );
};
